/** Refresh shared allowances without treating resource exhaustion as expired access. */
export const USAGE_UPDATED_EVENT = 'mio:usage-updated';

export function notifyUsageError(code: string | undefined) {
  if (code !== 'usage_limit_exceeded') return false;
  window.dispatchEvent(new Event(USAGE_UPDATED_EVENT));
  return true;
}
